import React from 'react';
import { Leaf, ArrowLeft, Upload, FileSpreadsheet } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useDropzone } from 'react-dropzone';

interface PatientLeadHeaderProps {
  onAddNewLead: () => void;
  onFileDrop: (acceptedFiles: File[]) => void;
  isDragActive: boolean;
}

export function PatientLeadHeader({ onAddNewLead, onFileDrop, isDragActive }: PatientLeadHeaderProps) {
  const navigate = useNavigate();
  
  const { getRootProps, getInputProps } = useDropzone({
    accept: {
      'text/csv': ['.csv'],
      'application/vnd.ms-excel': ['.csv', '.xls'],
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['.xlsx']
    },
    onDrop: onFileDrop,
    multiple: false
  });
  
  return (
    <div className="bg-white shadow-lg rounded-lg mb-6 overflow-hidden">
      <div className="relative">
        <div className="absolute inset-0 bg-gradient-to-r from-green-600 to-blue-600 opacity-90"></div>
        <div className="relative px-8 py-12">
          <div className="flex items-center justify-between">
            <button
              onClick={() => navigate('/dashboard')}
              className="text-white hover:text-green-100 transition-colors duration-200"
            >
              <ArrowLeft className="h-6 w-6" />
            </button>
            <div className="flex items-center space-x-4">
              <div 
                {...getRootProps()} 
                className={`bg-white/10 backdrop-blur-sm rounded-lg px-4 py-2 text-white hover:bg-white/20 cursor-pointer ${
                  isDragActive ? 'bg-white/30 ring-2 ring-white' : ''
                }`}
              >
                <input {...getInputProps()} />
                <Upload className="h-4 w-4 inline mr-2" />
                Import from CSV
              </div>
              <Leaf className="h-12 w-12 text-white opacity-20" />
            </div>
          </div>
          
          <div className="mt-4 text-center">
            <h1 className="text-4xl font-bold text-white mb-2">THRIVE</h1>
            <p className="text-green-100 text-lg mb-4">
              Tracking Health and Reducing Illness Via Efficiency
            </p>
            <div className="w-16 h-1 bg-white/30 mx-auto rounded-full"></div>
            <h2 className="text-2xl font-semibold text-white mt-4">New Patient Leads</h2>
          </div>
        </div>
      </div>
    </div>
  );
}